var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSandTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#37992E;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hourglass"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.5,23H19.14a10.65,10.65,0,0,0-1.21-7.76,9.85,9.85,0,0,0-2.57-2.74,9.85,9.85,0,0,0,2.57-2.74A10.65,10.65,0,0,0,19.14,2H20.5a.5.5,0,0,0,0-1H4.5a.5.5,0,0,0,0,1H5.86A10.65,10.65,0,0,0,7.07,9.76,9.85,9.85,0,0,0,9.64,12.5a9.85,9.85,0,0,0-2.57,2.74A10.65,10.65,0,0,0,5.86,23H4.5a.5.5,0,0,0,0,1h16a.5.5,0,0,0,0-1ZM6.89,23a9.65,9.65,0,0,1,1-7.24,8.85,8.85,0,0,1,2.84-2.84h0l.08-.07.07-.08h0s0,0,0-.07a1,1,0,0,1,0-.1v-.2a1,1,0,0,1,0-.1s0-.05,0-.07h0a.6.6,0,0,0-.08-.08s0-.05-.06-.06h0A8.85,8.85,0,0,1,7.93,9.24,9.65,9.65,0,0,1,6.89,2H18.11a9.65,9.65,0,0,1-1,7.24,8.85,8.85,0,0,1-2.84,2.84h0l-.07.06-.07.08h0s0,0,0,.07a1,1,0,0,1,0,.1v.2a1,1,0,0,1,0,.1s0,.05,0,.07h0a.54.54,0,0,0,.15.15,8.85,8.85,0,0,1,2.84,2.84,9.65,9.65,0,0,1,1,7.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.5,11h.06a8,8,0,0,0,3.22-1.08A2.29,2.29,0,0,0,17,7.36.5.5,0,0,0,16.5,7h-8A.5.5,0,0,0,8,7.36a2.29,2.29,0,0,0,1.2,2.56A8,8,0,0,0,12.44,11ZM9,8H16a1.6,1.6,0,0,1-.82,1.08A7,7,0,0,1,12.5,10a7,7,0,0,1-2.72-.92A1.6,1.6,0,0,1,9,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.6,16h-.2a6.09,6.09,0,0,0-3.27,1.83A4.46,4.46,0,0,0,8,21.58.5.5,0,0,0,8.5,22h8a.5.5,0,0,0,.49-.42,4.46,4.46,0,0,0-1.12-3.75A6.09,6.09,0,0,0,12.6,16Zm3.45,5H9a3.53,3.53,0,0,1,.92-2.51A5.27,5.27,0,0,1,12.5,17a5.27,5.27,0,0,1,2.63,1.49A3.53,3.53,0,0,1,16.05,21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.85,12.15a.36.36,0,0,0-.16-.11.5.5,0,0,0-.38,0,.36.36,0,0,0-.16.11.48.48,0,0,0,0,.7.36.36,0,0,0,.16.11.47.47,0,0,0,.38,0,.36.36,0,0,0,.16-.11.48.48,0,0,0,0-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.69,14a.5.5,0,0,0-.38,0,.36.36,0,0,0-.16.11.47.47,0,0,0-.15.35.43.43,0,0,0,0,.19.53.53,0,0,0,.27.27.43.43,0,0,0,.19,0,.41.41,0,0,0,.19,0,.53.53,0,0,0,.27-.27.43.43,0,0,0,0-.19.47.47,0,0,0-.15-.35A.36.36,0,0,0,12.69,14Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandTimer);
export default __webpack_public_path__ + "static/media/sand-timer.0e7cf0a164b56c7c08d8dbdc01083ba1.svg";
export { ForwardRef as ReactComponent };